<template>
  <transition name="slide" appear>
      <div class="mobile-pop-main" v-if="visible">
        <div class="content">
            <p>This site is best experienced on a desktop or laptop.</p>
            <button class="close" @click="toggleVisibility">OK</button>
        </div>
      </div>
  </transition>
</template>

<script>
export default {
  name: "MobilePop",

  data() {
    return {
      visible: true,
    }
  },
  methods: {
    toggleVisibility() {
      this.visible = !this.visible
    },
  },

}
</script>

<style scoped>
.mobile-pop-main {
    position: fixed;
    z-index: 99;
    align-content: center;
    background-color: var(--pale);
    border-radius: .5em .5em 0 0;
    width: 100%;
    top: 0;
    left: 0;
    border-radius: 0 0 .5em 0;
}

.content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: .25em 1em;
}

p {
    font-size: .65em;
    padding-right: 2em;
}

.close {
    display: inline;
    font: inherit;
    background: none;
    color: inherit;
    border: none;
    cursor: pointer;
    outline: inherit;
    line-height: 1.15;
    pointer-events: auto;
    padding: 1em;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 1s;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(-100%);
}

@media screen and (min-width: 400px) {
    .mobile-pop-main {
        width: 16em;
    }

    .info-head {
        margin: .7em 1em;
    }

    .info-wrapper-click-objects .info-body {
        padding-left: 3em;
        width: 12em;
    }
}

</style>
